import React from "react";
import { Link } from "gatsby"
import {capitalize} from "lodash"
import { defaultArea, defaultArea_Slug, country, PopularSearch_Types, PopularSearch_Areas } from "../../../../common/constant"
import { PropertySearchUrl } from "../../../../common/utils/property_utils"

const PropertyTypes = ({searchParams, property_type_list}) => {

    var area = searchParams.areas ? (searchParams.areas === defaultArea.toLowerCase() ? country : searchParams.areas.replace(/"/g, "")) : country;
    if(area.length < 5){
        area = area.toUpperCase();
    } else {
        area = capitalize(area);
    }

    var area_slug = searchParams.areas ? searchParams.areas : defaultArea_Slug;
    area_slug = (area_slug.replace(/ /g, '-')).toLowerCase();
    
    var property_url = PropertySearchUrl("residential", searchParams.search_type)

    
    var filter_prop_type = searchParams.propertyType ? (property_type_list?.length > 0 && property_type_list.filter(item => item.value === searchParams.propertyType)) : "";
    var prop_type = searchParams.propertyType;
    if(filter_prop_type?.length > 0){
        prop_type = filter_prop_type[0].label.replace(/\//g,' and ');
    }

    const PropertyTypeLinks = ({property_url, area_slug, searchParams, item, area}) =>{
        return(
            searchParams.bedrooms && searchParams.propertyType ?
                <li><Link to={`${property_url}in-${item.value}/type-${searchParams.propertyType}/`}>{prop_type} {searchParams.action} in {item.label}</Link></li>
            :
                <li><Link to={`${property_url}in-${area_slug}/type-${item.value}/`}>{item.label} {searchParams.action} in {area}</Link></li>
        )
    }

    return (<>
        <ul>
        {searchParams.bedrooms && searchParams.propertyType ?
            <>
                {PopularSearch_Areas.map((item) => {
                    return(<>
                        {/* <li><Link to={`${property_url}in-${item.value}/type-${searchParams.propertyType}`}>{prop_type} {searchParams.action} in {item.label}</Link></li>                         */}
                        <PropertyTypeLinks property_url={property_url} area_slug={area_slug} item={item} searchParams={searchParams} area={area} prop_type={prop_type}/>
                    </>)
                })}
            </>
            :
            <>
                {PopularSearch_Types.map((item) => {
                    return(
                        // <li><Link to={`${property_url}in-${area_slug}/type-${item.value}/`}>{item.label} {searchParams.action} in {area}</Link></li>

                        <PropertyTypeLinks property_url={property_url} area_slug={area_slug} item={item} searchParams={searchParams} area={area}/>
                    )                
                    })
                } 
            </>
        }                   
        </ul>
    </>)
}
export default PropertyTypes;